/* eslint-disable react/no-unknown-property */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

export const TimeRemindIcon = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    {...props}
  >
    <path
      d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2Zm4.3 13.2L11 12.3V7h1.5v4.4l4.5 2.5-.7 1.3Z"
      fill="currentColor"
    />
  </svg>
);

export const TimerIcon = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 28"
    width="23"
    height="28"
    {...props}
  >
    <g clipPath="url(#timericon)">
      <path
        d="M3.8 25.8c-.6-1-.4-1.5-.1-2.3l17.6-1.9c.7.8.8 1.4.2 2.3-6 2.6-11.8 3.1-17.7 2Z"
        fill="#C67C54"
        stroke="#000"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M2.1 5c.6 3.7 2.8 7 6 8.9a15.8 15.8 0 0 0-3.7 4.3c-.9 1.8-1 4 0 5.5 3.8.7 8.8.2 14.4-1 .7 0 1.5-.3 2-.8.6-.7.6-2.3-1.2-4.7a15 15 0 0 0-5-4S19.3 9.3 19 1.9C13.5 2.9 8.1 3.7 2.7 4"
        fill="#E7F4FF"
      />
      <path
        d="M2.1 5c.6 3.7 2.8 7 6 8.9a15.8 15.8 0 0 0-3.7 4.3c-.9 1.8-1 4 0 5.5 3.8.7 8.8.2 14.4-1 .7 0 1.5-.3 2-.8.6-.7.6-2.3-1.2-4.7a15 15 0 0 0-5-4S19.3 9.3 19 1.9C13.5 2.9 8.1 3.7 2.7 4"
        stroke="#000"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19 1.4c.5 1.4 1 1.3.6 2.2-6 1-12 1.7-18.2 2-.7-1-.7-1.2-.2-2.3C7.7 1.8 13 1.7 19 1.4h0Z"
        fill="#C67C54"
        stroke="#000"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.4 17.8c-2.1.2-5.3 3.7-5.2 4 2 1.7 8.6.6 12.7-1.2 0 0-5.3-3-7.5-2.8ZM11.7 13.7c1.5-1 4.3-3 4.5-4.7-2.7-.8-9-.7-10.6.9 1.4 1.8 3.2 2.8 5.2 3.8h1Z"
        fill="#ECCC62"
      />
    </g>
    <defs>
      <clipPath id="timericon">
        <path fill="#fff" d="M0 0H22.7V28H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const TimerFixedPanelIcon = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 28"
    width="23"
    height="28"
    {...props}
  >
    <g clipPath="url(#timermobileicon)">
      <path
        d="M3.8 25.8c-.6-1-.4-1.5-.1-2.3l17.6-1.9c.7.8.8 1.4.2 2.3-6 2.6-11.8 3.1-17.7 2Z"
        fill="#C67C54"
        stroke="#000"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M2.1 5c.6 3.7 2.8 7 6 8.9a15.8 15.8 0 0 0-3.7 4.3c-.9 1.8-1 4 0 5.5 3.8.7 8.8.2 14.4-1 .7 0 1.5-.3 2-.8.6-.7.6-2.3-1.2-4.7a15 15 0 0 0-5-4S19.3 9.3 19 1.9C13.5 2.9 8.1 3.7 2.7 4"
        fill="#E7F4FF"
      />
      <path
        d="M2.1 5c.6 3.7 2.8 7 6 8.9a15.8 15.8 0 0 0-3.7 4.3c-.9 1.8-1 4 0 5.5 3.8.7 8.8.2 14.4-1 .7 0 1.5-.3 2-.8.6-.7.6-2.3-1.2-4.7a15 15 0 0 0-5-4S19.3 9.3 19 1.9C13.5 2.9 8.1 3.7 2.7 4"
        stroke="#000"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19 1.4c.5 1.4 1 1.3.6 2.2-6 1-12 1.7-18.2 2-.7-1-.7-1.2-.2-2.3C7.7 1.8 13 1.7 19 1.4h0Z"
        fill="#C67C54"
        stroke="#000"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.4 17.8c-2.1.2-5.3 3.7-5.2 4 2 1.7 8.6.6 12.7-1.2 0 0-5.3-3-7.5-2.8ZM11.7 13.7c1.5-1 4.3-3 4.5-4.7-2.7-.8-9-.7-10.6.9 1.4 1.8 3.2 2.8 5.2 3.8h1Z"
        fill="#ECCC62"
      />
    </g>
    <defs>
      <clipPath id="timermobileicon">
        <path fill="#fff" d="M0 0H22.7V28H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const WalletIcon = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 85 80"
    width="85"
    height="80"
    {...props}
  >
    <g clipPath="url(#connect)">
      <path
        d="M9.7 30.3c-3.9.6-6.2-1-6.8-5-.6-3.8 1-6.1 5-6.7L68.4 9s2.4-.3 2.7 2l1.5 9.4-63 10Z"
        fill="#C89005"
      />
      <path
        d="m72.9 21.6-63 9.9c-4.6.7-7.4-1.4-8.2-6-.7-4.5 1.4-7.4 6-8.1l60.6-9.6c1.4-.2 3.7.4 4.1 3l1.5 9.4c0 .7-.4 1.3-1 1.4Zm-4.2-11.4L8 19.7c-3.3.5-4.4 2.2-4 5.5.6 3.3 2.2 4.5 5.5 4l61.9-9.8-1.3-8.2c-.2-1-1-1-1.4-1Z"
        fill="#231C1C"
      />
      <path
        d="M74.9 38.8c.4 1.2-.2 2.5-1.4 3l-53.2 20c-1.2.4-2.5-.2-3-1.5L5.3 28c-.5-1.3.1-2.6 1.4-3.1l53-20c1.3-.4 2.6.3 3.2 1.5l12 32.4Z"
        fill="#C11F29"
      />
      <path
        d="M20 63c-1.6.3-3.2-.7-3.8-2.3l-12-32.3c-.4-.9-.3-1.9 0-2.8.4-.9 1.1-1.5 2-1.9L59.3 3.8c1.9-.6 4 .3 4.6 2.1l12 32.3c.6 1.9-.3 4-2 4.6L20.6 62.7c-.2.3-.4.3-.6.3ZM60.5 6l-.2.1L7 26.1c-.6.1-1 .8-.7 1.5l12 32.3c.2.6.8 1 1.5.7L73 40.7c.4-.1.6-.3.7-.6v-1L61.6 7c-.2-.6-.7-1-1.3-.8Z"
        fill="#231C1C"
      />
      <path
        d="M67.2 18.3c.3.8-.4 1.8-1.6 2.3L12.5 40.5c-1.3.4-2.5.1-2.8-.7l-1.4-3.7c-.2-.8.4-1.9 1.7-2.3l53-20c1.3-.4 2.6 0 2.8.7l1.4 3.8Z"
        fill="#513328"
      />
      <path
        d="M12 41.9c-1.6.2-3-.4-3.4-1.7l-1.4-3.6c-.6-1.5.4-3.2 2.4-3.9l53-19.9c1.9-.6 3.8 0 4.4 1.4l1.4 3.8c.6 1.4-.5 3.2-2.4 3.8l-53.1 20h-1Zm52-27-.5.1-53.1 19.9c-.7.2-1 .6-1 .9l1.5 3.6c0 .1.6.2 1.1 0l53.1-20c.7-.2 1-.6 1-.7L64.7 15H64ZM38.7 43.4l10-3.8.8 2.3-10 3.7-.8-2.2Zm-5 7L57 41.5l.8 2.2-23.2 8.7-.8-2.2Z"
        fill="#231C1C"
      />
      <path
        d="M71.5 57.4a2.2 2.2 0 0 1-2.7 2L9 50.7A2.4 2.4 0 0 1 7 48l5-35.4a2.2 2.2 0 0 1 2.6-2l59.9 8.6c1.2.2 2.1 1.3 2 2.7l-5.1 35.4Z"
        fill="#B8CA43"
      />
      <path
        d="M69.7 60.6c-.3.1-.7.2-1 .1L8.8 52c-1 0-1.8-.7-2.4-1.4-.6-.8-.7-1.7-.7-2.7l5-35.4c.3-2 2-3.3 4-3l59.8 8.6c2 .3 3.2 2.1 3 4l-5 35.3c0 1-.5 1.8-1.2 2.4-.6.4-1.1.8-1.7.9ZM14.2 12c-.5 0-.9.5-1 1l-5 35.3c0 .4 0 .7.4 1 .1.2.4.4.8.4L69 58.2c.2.1.6 0 .8-.2l.5-.8 5-35.4c0-.6-.4-1.3-1-1.3l-60-8.5-.2-.1Z"
        fill="#231C1C"
      />
      <path
        d="m67 48.3 2.6-18.8c-2.6-.4-4.3-2.9-4-5.4l-43.8-6.3a4.7 4.7 0 0 1-5.2 4l-2.7 19c2.6.3 4.3 2.8 4 5.3l43.7 6.3a4.9 4.9 0 0 1 5.3-4Z"
        fill="#B8CA43"
      />
      <path
        d="m62.6 53.7-46-6.6.2-1.3c0-1 0-1.9-.7-2.6a3.4 3.4 0 0 0-2.2-1.4l-1.3-.1 3-21.2 1.3.1c1.8.3 3.6-1 4-3v-1.2L67 23l-.1 1.2c-.1 1 0 2 .6 2.7.6.7 1.4 1.2 2.3 1.3l1.2.2-3 21.2-1.3-.2c-1.8-.3-3.6 1-4 3v1.3ZM19.2 45l41.6 6a5.6 5.6 0 0 1 5.1-4l2.4-16.7c-1-.5-2-1.1-2.7-2-.8-1-1-2-1.1-3.2l-41.6-6a5.7 5.7 0 0 1-5.1 4l-2.5 16.6c1 .4 2 1.1 2.7 2 .7 1 1.1 2.1 1.2 3.3Z"
        fill="#231C1C"
      />
      <path
        d="M39.4 51.6c4 .5 8-.6 11.3-3.3 3.2-2.7 5.4-6.7 6-11 .6-4.4-.4-8.9-2.8-12.4-2.3-3.5-6-5.7-9.9-6.3-4-.6-8 .6-11.3 3.3a17.5 17.5 0 0 0-6 11c-.6 4.4.4 8.8 2.8 12.3s6 5.8 9.9 6.4Z"
        fill="#E1E0A6"
      />
      <path
        d="M43.7 52.7a16 16 0 0 1-15.2-6.9 18.8 18.8 0 0 1-3-13.2c.8-4.7 3-8.9 6.5-11.7 3.5-3 7.8-4.2 12.1-3.6 9 1.3 15 10.3 13.7 20-1 8.1-7 14.3-14.1 15.4Zm-3.6-33c-2.4.4-4.6 1.5-6.6 3.1a16 16 0 0 0-5.6 10.3c-.5 4 .4 8.2 2.5 11.4a13 13 0 0 0 9 5.8c7.7 1.1 14.9-4.8 16-13.3 1.2-8.5-4-16.2-11.6-17.3H40Z"
        fill="#231C1C"
      />
      <path d="m38.2 51.4 4.6-33 2.4.4-4.6 33-2.4-.4Z" fill="#231C1C" />
      <path
        d="M42 48a6 6 0 0 1-2 0 7 7 0 0 1-4.8-3 7.7 7.7 0 0 1-1.2-5l2.4.3a5 5 0 0 0 .7 3.4c.8 1.1 1.9 1.9 3.2 2 2.6.4 5-1.4 5.2-4 .4-2.6-1.3-5-4-5.4a7.1 7.1 0 0 1-3.1-12.8 7 7 0 0 1 5.1-1.4 7 7 0 0 1 6 8.1l-2.3-.3a4.7 4.7 0 0 0-4-5.3 4.6 4.6 0 0 0-5.2 4c-.3 2.6 1.4 5 4 5.4 3.8.7 6.5 4.2 5.9 8.1-.5 3-3 5.5-5.9 6Z"
        fill="#231C1C"
      />
      <path
        d="M83.2 64.5c.2 1.3-.6 2.6-2 2.8L13.7 77.9c-1.3.2-2.6-.7-2.8-2L3 25.4c.6 3.5 3.3 5.5 6.8 5l64.2-10.2c1.3-.2 2.5.7 2.7 2l6.6 42.3Z"
        fill="#EEBE00"
      />
      <path
        d="M81.5 68.4 13.7 79.1c-2 .3-3.7-1-4-3l-8-50.6c0-.7.3-1.2 1-1.3.7-.1 1.3.3 1.4 1 .4 2.8 2.6 4.4 5.4 4L73.7 19c2-.4 3.7 1 4 3l6.7 42.3c.3 2-1 3.7-3 4ZM4.9 30.6 12 75.7c.1.7.7 1.1 1.4 1L81 66.1c.7-.1 1-.7 1-1.4l-6.7-42.3c0-.7-.6-1.1-1.3-1l-64.2 10a7 7 0 0 1-5-.8Z"
        fill="#231C1C"
      />
      <path
        d="m80.8 49.3-13.6 2.1c-2.8.4-5.4-1.3-5.8-4l-.4-2.3c-.4-2.5 1.5-5 4.3-5.5l13.8-2.1L81 49.2h-.2Z"
        fill="#C89005"
      />
      <path
        d="m81 50.4-13.6 2.2a6.1 6.1 0 0 1-7.2-5l-.3-2.3a6.1 6.1 0 0 1 5.2-6.8L79 36.3c.7-.1 1.3.3 1.4 1L82 49.1c0 .7-.4 1.2-1 1.3Zm-15.5-9.6c-2 .4-3.6 2.2-3.3 4.2l.4 2.3c.3 2 2.3 3.3 4.4 3l12.6-2-1.5-9.5-12.6 2ZM10.6 35l5.6-.9.4 2.4-5.6.8-.4-2.3ZM20 33.5l5.6-.9.4 2.4-5.7.9-.3-2.4ZM29.3 32l5.6-.8.4 2.3-5.6.9-.4-2.3ZM38.7 30.6l5.6-.9.3 2.4-5.6.8-.3-2.3ZM48 29.1l5.6-.9.4 2.4-5.6.9L48 29ZM57.3 27.6l5.6-.8.4 2.3-5.6.9-.4-2.4ZM66.7 26.2l5.6-.9.4 2.4-5.6.8-.4-2.3ZM16.2 70.3l5.6-1 .4 2.4-5.7 1-.3-2.4ZM25.5 68.8l5.6-.9.4 2.4-5.6.8-.4-2.3ZM34.9 67.3l5.6-.9.3 2.4-5.6.9-.3-2.4ZM44.2 65.9l5.6-1 .4 2.4-5.6 1-.4-2.4ZM53.5 64.4l5.6-.9.4 2.4-5.6.8-.4-2.3ZM62.9 63l5.6-1 .4 2.4-5.7.9-.3-2.4ZM72.2 61.5l5.6-1 .4 2.4-5.6 1-.4-2.4Z"
        fill="#231C1C"
      />
      <path
        d="M64.7 45.8a2.4 2.4 0 0 0 2.7 2 2.4 2.4 0 0 0 2-2.8 2.4 2.4 0 0 0-2.7-2 2.4 2.4 0 0 0-2 2.8Z"
        fill="#231C1C"
      />
    </g>
    <defs>
      <clipPath id="connect">
        <path fill="#fff" d="M0 0H85V79.6H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const WarningMsgIcon = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    {...props}
  >
    <circle cx="12" cy="12" r="10.5" fill="#fff" stroke="#000" />
    <path
      d="M13 13h-2V7h2m0 10h-2v-2h2M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z"
      fill="#FF2121"
    />
  </svg>
);

export const ErrorMsgIcon = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    {...props}
  >
    <circle cx="12" cy="12" r="11.5" fill="red" stroke="#000" />
    <path
      d="m16.6 9.2-1.4-1.4-3.3 3.4-3.3-3.4-1.3 1.4 3.3 3.3-3.3 3.3 1.3 1.3 3.3-3.3 3.3 3.3 1.4-1.3-3.4-3.3 3.4-3.3Z"
      fill="#fff"
    />
  </svg>
);

export const SuccessMsgIcon = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 24"
    width="25"
    height="24"
    {...props}
  >
    <circle cx="12.6" cy="12" r="11.5" fill="#00CD3C" stroke="#000" />
    <path d="m8 11.3 3 3 6.8-6.8" stroke="#fff" strokeWidth="2" />
  </svg>
);

export const ItemCheckedIcon = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="11"
      fill="#00CD3C"
      stroke="#000"
      strokeWidth="2"
    />
    <path d="m7.5 11.3 3 3 6.8-6.8" stroke="#fff" strokeWidth="2" />
  </svg>
);

export const MocaNotFoundIcon = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 72 72"
    width="72"
    height="72"
    {...props}
  >
    <g clipPath="url(#mocanotfound)">
      <circle cx="36" cy="36" r="31.4" fill="#EE9ABF" fillOpacity=".3" />
      <path
        d="M32.4 72h-.1a36 36 0 0 1-7.4-1.6 1.3 1.3 0 0 1 .8-2.4c2.2.7 4.5 1.2 6.8 1.4.7 0 1.3.7 1.2 1.4 0 .7-.6 1.2-1.3 1.2Zm7.3 0a1.3 1.3 0 0 1-.2-2.6c2.3-.2 4.6-.7 6.8-1.4a1.3 1.3 0 0 1 .9 2.4 36 36 0 0 1-7.4 1.6h-.1Zm-21-4.4-.7-.2a35.9 35.9 0 0 1-6-4.4c-.6-.5-.6-1.3-.2-1.9.5-.5 1.3-.5 1.9 0 1.7 1.5 3.6 2.9 5.6 4a1.3 1.3 0 0 1-.6 2.5Zm34.7 0a1.3 1.3 0 0 1-.7-2.5c2-1.2 4-2.6 5.7-4.1.5-.5 1.3-.5 1.8 0 .5.6.4 1.4-.1 1.9a36.4 36.4 0 0 1-6.7 4.6ZM7.9 57.8c-.3 0-.7-.2-1-.5a36 36 0 0 1-3.8-6.6c-.3-.6 0-1.4.7-1.7.6-.3 1.4 0 1.7.7a33 33 0 0 0 3.5 6A1.3 1.3 0 0 1 8 58Zm56.2 0c-.3 0-.5-.1-.8-.3-.6-.4-.7-1.2-.3-1.8a34 34 0 0 0 3.5-6c.3-.7 1-1 1.7-.7.7.2 1 1 .7 1.7-1 2.3-2.3 4.5-3.8 6.5-.2.3-.6.5-1 .5ZM2 44.6c-.6 0-1.2-.4-1.3-1-.5-2.5-.8-5-.8-7.5 0-.8.6-1.3 1.3-1.3.7 0 1.3.5 1.3 1.3 0 2.3.2 4.7.7 7a1.3 1.3 0 0 1-1.2 1.5Zm67.9 0-.3-.1c-.7-.2-1.2-.8-1-1.5.5-2.3.7-4.7.7-7V36c0-.8.6-1.3 1.3-1.3.7 0 1.3.5 1.3 1.3 0 2.6-.3 5.1-.8 7.6-.1.6-.6 1-1.2 1ZM2 30.1h-.2c-.7-.1-1.2-.8-1-1.5A36 36 0 0 1 3 21.5c.2-.7 1-1 1.7-.7.6.3 1 1 .6 1.7a34 34 0 0 0-2.1 6.7c-.2.6-.7 1-1.3 1Zm68-.2c-.7 0-1.2-.4-1.3-1-.5-2.3-1.3-4.5-2.2-6.7-.3-.6 0-1.4.6-1.7.7-.3 1.4 0 1.7.7 1 2.3 1.9 4.7 2.4 7.1a1.3 1.3 0 0 1-1.3 1.6ZM7.8 17c-.3 0-.6 0-.8-.2-.6-.5-.7-1.3-.3-1.8 1.5-2 3.2-4 5-5.7.6-.4 1.4-.4 1.9.1.4.6.4 1.4-.1 1.9a33.4 33.4 0 0 0-4.7 5.2c-.2.3-.6.5-1 .5Zm56.1-.2c-.4 0-.8-.1-1-.5-1.4-1.9-3-3.6-4.7-5.2-.6-.5-.6-1.3-.1-1.8.4-.5 1.3-.6 1.8-.1 1.9 1.7 3.6 3.5 5 5.6a1.3 1.3 0 0 1-1 2ZM18.6 7.3a1.3 1.3 0 0 1-.7-2.4c2.2-1.3 4.5-2.3 6.9-3.1.7-.2 1.4.1 1.6.8.2.7-.1 1.4-.8 1.6-2.2.8-4.4 1.7-6.4 3h-.6Zm34.7-.1c-.3 0-.5 0-.7-.2a34 34 0 0 0-6.4-2.8 1.3 1.3 0 0 1 .8-2.5c2.4.8 4.7 1.8 6.9 3a1.3 1.3 0 0 1-.7 2.5Zm-21-4.4c-.7 0-1.2-.5-1.3-1.2C31 1 31.4.3 32 .2c2.5-.3 5-.3 7.6 0 .7 0 1.2.7 1.1 1.4 0 .7-.7 1.2-1.4 1.2-2.3-.3-4.7-.3-7 0h-.1ZM39.8 46.1c.1.7-.3 1.4-1 1.6a11.2 11.2 0 0 1-4.2.6h-1.5c-1.4 0-1.7-.8-1.7-1.1 0-.3 0-.6.2-.8.3-.3.9-.5 1.6-.6h2.5l1-.1h.5L37 45l-.4-1.4-1.8-4.5V39l-1-2.2a8 8 0 0 1-.2-.6h.3l.3.1h2l.3.6.7 1.9a734.5 734.5 0 0 1 2.6 7.3ZM51.4 18.4a10.3 10.3 0 0 0-9.6 6.3 7.7 7.7 0 0 1 0 8l1.5 2.4a10.3 10.3 0 1 0 8-16.7Zm0 18a7.8 7.8 0 0 1-7.8-7.7 7.7 7.7 0 0 1 15.5 0c0 4.2-3.4 7.7-7.7 7.7Z"
        fill="#000"
      />
      <path
        d="M51.4 32.4c2.1 0 3.8-1.7 3.8-3.7a3.8 3.8 0 0 0-7.5 0c0 2 1.7 3.7 3.7 3.7ZM28.5 24.9c-.4-1-.9-1.8-1.5-2.5a10.3 10.3 0 1 0 1.4 10 7.7 7.7 0 0 1 0-7.5Zm-9.7 11.5a7.7 7.7 0 1 1 0-15.5 7.7 7.7 0 0 1 0 15.5Z"
        fill="#000"
      />
      <path
        d="M44.7 24.7a10.3 10.3 0 1 0-10 14.3h1.6l.2-.1h.5l.2-.1a10.4 10.4 0 0 0 7.5-14Zm-8.5 11.6H33.6a7.8 7.8 0 0 1-6.2-7.6 7.8 7.8 0 0 1 15.5 0 7.7 7.7 0 0 1-6.7 7.6Z"
        fill="#000"
      />
      <path
        d="M39 28.7a3.8 3.8 0 1 1-7.5 0 3.8 3.8 0 0 1 7.5 0ZM18.5 32.4c2.1 0 3.8-1.7 3.8-3.7a3.8 3.8 0 0 0-7.6 0c0 2 1.7 3.7 3.8 3.7Z"
        fill="#000"
      />
    </g>
    <defs>
      <clipPath id="mocanotfound">
        <path fill="#fff" d="M0 0H72V72H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const MocaOopsIcon = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 72 72"
    width="72"
    height="72"
    {...props}
  >
    <g clipPath="url(#mocaOopsa)">
      <path
        d="M36.7 70.5a34.7 34.7 0 1 1 .1-69.4 34.7 34.7 0 0 1 0 69.4Z"
        fill="#EE9ABF"
      />
      <path
        d="M36 2.6a33.4 33.4 0 1 1 0 66.8 33.4 33.4 0 0 1 0-66.8ZM36 0a36 36 0 1 0 .1 72A36 36 0 0 0 36 0Z"
        fill="#000"
      />
      <path
        d="m38.4 45.5-.7-2.2-2.6-6.7-.5-1.3c0-.4 0-.9.4-1.2.4-.3 1 0 1.4.6l.3.7a1030.2 1030.2 0 0 1 3.8 10.4c0 .6-.2 1.1-.8 1.3l-2.4.6a29 29 0 0 1-3.3 0c-1 0-1.4-.3-1.5-.9 0-.6.5-1 1.6-1l2.5-.1 1.8-.2Z"
        fill="#000"
      />
      <path
        d="M35.5 48H34c-1.5 0-1.7-.8-1.8-1.2 0-.2 0-.5.3-.7.3-.4.8-.6 1.6-.6h2.5l1-.2h.5l-.2-.5-.4-1.4-1.8-4.6-1-2.4-.3-1c-.2-.8.1-1.3.5-1.5.2-.1.4-.2.7-.1.4 0 .7.4 1 .8l.3.8.5 1 3 7.7.4 1.7c0 .7-.3 1.3-1 1.5a11.8 11.8 0 0 1-4.3.7Zm-.5-2H34c-.6 0-1 .2-1.2.4l-.2.4c.1.6.9.7 1.3.7H37.3l2.3-.6c.5-.2.7-.6.7-1a881 881 0 0 0-3.4-9.1l-.4-1.3-.4-.7c-.1-.3-.4-.5-.6-.5H35c-.3.2-.4.5-.2 1l.3 1 1 2.3a478.4 478.4 0 0 1 2.2 6l.2.8v.3h-.2l-.6.1-1.2.1H34.9Z"
        fill="#000"
      />
      <path
        d="M35 46.4H34c-.5 0-.9.2-1 .3 0 .3.8.3.9.3h3.2c.8 0 1.7-.3 2.3-.5.3-.1.3-.5.3-.6l-.3-1.5-2.8-7.1-.6-1.6-.3-.7c-.2-.3-.4-.3-.5-.3 0 0-.2 0 0 .5 0 .3.1.6.3.8l1 2.5 1.7 4.6.5 1.4.2.8.2.7-1.4.2-1.2.2H35Z"
        fill="#000"
      />
      <path
        d="M35.5 47.3H34c-.7 0-1-.2-1.1-.6v-.1c.2-.3.7-.4 1.2-.4h2.5l1.2-.2 1.1-.2-.1-.4-.2-.8-.5-1.4-1.8-4.6-1-2.5-.3-.9c-.1-.5 0-.6.2-.7l.1-.1h.2l.5.5.3.7.6 1.6a970 970 0 0 1 3.2 8.7c0 .4-.2.7-.5.8a11.5 11.5 0 0 1-4.1.6Zm-2-.6.5.1h3.2l2.2-.5-1.6.2a10.2 10.2 0 0 1-2.2.1H34a2 2 0 0 0-.6.2Zm2-11.6c0 .3.2.6.3.8l1 2.5a481 481 0 0 1 2.2 6l.2.8.3 1v-.3c0-.4 0-.9-.2-1.4l-2.8-7.1-.6-1.6a5.8 5.8 0 0 0-.4-.7Z"
        fill="#000"
      />
      <path d="M52.4 37.3a9 9 0 1 0 0-18.2 9 9 0 0 0 0 18.2Z" fill="#fff" />
      <path
        d="M52.4 38.6a10.4 10.4 0 1 1 0-20.8 10.4 10.4 0 0 1 0 20.8Zm0-18.2a7.8 7.8 0 1 0 0 15.6 7.8 7.8 0 0 0 0-15.6Z"
        fill="#000"
      />
      <path d="M52.4 32a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6Z" fill="#000" />
      <path d="M19.6 37.3a9 9 0 1 0 0-18.2 9 9 0 0 0 0 18.2Z" fill="#fff" />
      <path
        d="M19.6 38.6a10.4 10.4 0 1 1 0-20.8 10.4 10.4 0 0 1 0 20.8Zm0-18.2a7.8 7.8 0 1 0 0 15.6 7.8 7.8 0 0 0 0-15.6Z"
        fill="#000"
      />
      <path d="M22.4 14.1c-2 5.1-10.9 11.4-14.6 8.8Z" fill="#EE9ABF" />
      <path
        d="M10 24.8a5 5 0 0 1-3-.8c-.6-.4-.7-1.2-.3-1.9.4-.6 1.3-.7 1.9-.3.7.4 1.8.5 3.2 0a17 17 0 0 0 9.3-8.1c.3-.7 1-1 1.8-.8.6.3 1 1 .7 1.7a19.5 19.5 0 0 1-11 9.8c-1 .3-1.8.5-2.7.5Z"
        fill="#000"
      />
      <path d="M49.9 14.1c2 5.1 10.8 11.4 14.6 8.8Z" fill="#EE9ABF" />
      <path
        d="M62.3 24.8c-.8 0-1.7-.1-2.6-.4a19.5 19.5 0 0 1-11-9.8c-.3-.7 0-1.5.7-1.7.7-.3 1.5 0 1.8.7a17 17 0 0 0 9.3 8.2c1.4.4 2.5.4 3.2 0 .6-.5 1.4-.3 1.9.3.4.6.2 1.5-.4 1.9a5 5 0 0 1-2.9.8Z"
        fill="#000"
      />
      <path d="M36 37.3A9 9 0 1 0 36 19a9 9 0 0 0 0 18.2Z" fill="#fff" />
      <path
        d="M36 38.6a10.4 10.4 0 1 1 0-20.8 10.4 10.4 0 0 1 0 20.8Zm0-18.2A7.8 7.8 0 1 0 36 36a7.8 7.8 0 0 0 0-15.6Z"
        fill="#000"
      />
      <path
        d="M36.1 32a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6ZM19.3 32a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6Z"
        fill="#000"
      />
      <path
        d="M41.5 59c0 3-2.2 5.4-5 5.4-2.7 0-5-2.4-5-5.4 0-3 2.3-5.5 5-5.5 2.8 0 5 2.5 5 5.5Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.5 62.6c1.6 0 3.2-1.4 3.2-3.6s-1.6-3.7-3.2-3.7c-1.5 0-3.1 1.5-3.1 3.7s1.6 3.6 3.1 3.6Zm0 2.7c3.3 0 5.9-2.8 5.9-6.3s-2.6-6.4-5.9-6.4c-3.2 0-5.8 2.9-5.8 6.4 0 3.5 2.6 6.3 5.8 6.3Z"
        fill="#000"
      />
    </g>
    <defs>
      <clipPath id="mocaOopsa">
        <path fill="#fff" d="M0 0H72V72H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const HelpIcon = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="20"
    height="20"
    {...props}
  >
    <path d="M20 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z" fill="currentColor" />
    <path
      d="M9 10.4a1.8 1.8 0 0 1 .5-1.2l.4-.4a23.3 23.3 0 0 0 .7-.7l.1-.4c0-.2 0-.4-.3-.5-.1-.2-.4-.2-.7-.2-.3 0-.6 0-.8.2-.3.1-.5.3-.6.6l-1.7-1c.3-.4.7-.9 1.3-1.2.5-.3 1.2-.4 2-.4.7 0 1.2 0 1.6.2l1.1.7c.3.4.4.8.4 1.2a2 2 0 0 1-.5 1.4l-.4.5a28.3 28.3 0 0 0-.8.8l-.2.4h-2Zm1.1 3c-.4 0-.7 0-1-.3-.2-.3-.3-.5-.3-.9 0-.3.1-.6.4-.8.2-.2.5-.3 1-.3.3 0 .6 0 .8.3.3.2.4.5.4.8 0 .4-.1.6-.4.9-.2.2-.5.3-.9.3Z"
      fill="#fff"
    />
  </svg>
);

export const ArrowDownIcon = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 10"
    width="18"
    height="10"
    {...props}
  >
    <path
      d="M7.4 9.3 1.6 3.7C.9 3 .7 2.2 1 1.3 1.5.4 2.2 0 3.2 0h11.6c1 0 1.7.4 2 1.3.5.9.3 1.7-.4 2.4l-5.8 5.6-.8.4-.8.2a2.2 2.2 0 0 1-1.6-.6Z"
      fill="#000"
    />
  </svg>
);

export const ArrowRightIcon = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 11 17"
    width="10"
    height="17"
    {...props}
  >
    <path
      d="M9.6 10.4 4 16.2c-.7.7-1.5.9-2.4.5-.9-.4-1.3-1.1-1.3-2.1V3c0-1 .4-1.7 1.3-2C2.5.4 3.3.6 4 1.3l5.6 5.8.4.8.2.8a2.2 2.2 0 0 1-.6 1.6Z"
      fill="#000"
    />
  </svg>
);

export const CloseIcon = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width="48"
    height="48"
    {...props}
  >
    <circle
      cx="24"
      cy="24"
      r="22.5"
      fill="#F8D748"
      stroke="#000"
      strokeWidth="3"
    />
    <path
      d="M17.2 17.2a1.4 1.4 0 0 1 1.9 0l4.8 4.8 4.9-4.8a1.4 1.4 0 0 1 2 1.9l-5 4.8 5 4.9a1.4 1.4 0 0 1-2 2l-4.9-5-4.8 5a1.4 1.4 0 0 1-2-2l4.9-4.9-4.8-4.8a1.4 1.4 0 0 1 0-2Z"
      fill="#000"
    />
  </svg>
);

export const HideIcon = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 2"
    width="12"
    height="2"
    {...props}
  >
    <path fill="#0080CE" d="M0 0H12V2H0z" />
  </svg>
);

export const ShowIcon = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    width="14"
    height="14"
    {...props}
  >
    <path
      d="M6 13.4V7.9H.7V6.1h5.5V.6h1.8v5.5h5.5v1.8H7.9v5.5H6.1Z"
      fill="#0080CE"
    />
  </svg>
);
